import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SettingProps } from "./Settings";
import AsyncLocalStorage from "../../util/AsyncLocalStorage";
import UserController from "../../controller/UserController";

const ShareSetting = ({ setStep }: SettingProps) => {
  const [isShare, setIsShare] = useState<boolean>(false);
  const navigate = useNavigate();

  const getUserInfo = async () => {
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    console.log("oUserData", oUserData);
    if (oUserData.share_type === "single") {
      setIsShare(false);
    } else if (oUserData.share_type === "multi") {
      setIsShare(true);
    }
  };

  const setUserShareType = async (sShareType: string) => {
    let oUserData = await AsyncLocalStorage.getItem("accountSetting");
    if (sShareType === "single") {
      if (oUserData) {
        oUserData.share_type = "single";
        await AsyncLocalStorage.setItem(
          "accountSetting",
          JSON.stringify(oUserData)
        );

        if (oUserData.use_password === 1) {
          navigate("/payment/password", {
            state: {
              passwordType: "login",
              loginAccount: JSON.stringify(oUserData),
            },
          });
        } else {
          navigate("/home", { replace: true });
        }
      } else {
        navigate("/home", { replace: true });
      }
    } else if (sShareType === "multi") {
      if (oUserData) {
        oUserData.share_type = "multi";
        await AsyncLocalStorage.setItem(
          "accountSetting",
          JSON.stringify(oUserData)
        );
      }
      setIsShare(true);
      setStep!(2);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  return (
    <div className="wrapper">
      <h1 className="logo">차량을 공유하시겠습니까?</h1>
      <div className="listWrap">
        <div className={`buttonBorder ${!isShare && "active"}`}>
          <button
            onClick={() => {
              setUserShareType("single");
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_single.svg`}
              alt="single"
            />
            <h1>단독사용</h1>
          </button>
        </div>
        <div className={`buttonBorder ${isShare && "active"}`}>
          <button
            onClick={() => {
              setUserShareType("multi");
            }}
          >
            <img
              src={`${process.env.PUBLIC_URL}/svg/ic_union.svg`}
              alt="union"
            />
            <h1>공유자 있음</h1>
          </button>
        </div>
      </div>
    </div>
  );
};
export default ShareSetting;
